import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  overflowy: hidden;
`;

type Props = {
  children: React.ReactNode;
};

function FullPageLayout({ children }: Props): JSX.Element {
  return <Container>{children}</Container>;
}

export default FullPageLayout;
